var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "181",
        height: "136",
        viewBox: "0 0 181 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", { attrs: { width: "181", height: "136", fill: "#FECB17" } }),
      _c("circle", {
        attrs: { cx: "90.5", cy: "68.5", r: "65.5", fill: "#FFDC61" },
      }),
      _c("circle", {
        attrs: { cx: "90.5", cy: "68.5", r: "42.5", fill: "#FECB17" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }